import React, { useEffect, useState } from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import SalesBudgetYearInputLayout from 'components/organismos/master/storeManagement/salesBudgetYear/salesBudgetYearInputLayout';
import { getFiscalYearFromDate } from 'api/salesBudgetYear';

const SalesBudgetYearInput = () => {
  const [getYear, setYear] = useState();

  useEffect(() => {
    getFiscalYearFromDate().then((response) => {
      setYear(response.id.fiscalYear);
    });
  }, []);
  return (
    <SidebarTemplate pageTitle="予算編成">
      {getYear ? <SalesBudgetYearInputLayout getFiscalYear={getYear} /> : ''}
    </SidebarTemplate>
  );
};
export default SalesBudgetYearInput;
